export default class Overlay {
    bind() {
        const overlay = document.querySelector('.overlay');

        document.querySelector('.overlay .close').addEventListener('click', evt => {
            evt.preventDefault();

            overlay.parentNode.removeChild(overlay);
        });

        document.body.addEventListener('keyup', evt => {
            if (evt.keyCode === 27 && this.open) {
                this.open = false;

                overlay.parentNode.removeChild(overlay);

                document.body.removeEventListener('keyup');
            }
        });
    }
};
